import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  Badge,
  Btn,
  CustomCheckbox,
  CustomDropdown,
  CustomModal,
  CustomRadioButton,
  InputText,
} from '../../../../components'
import * as PickingHttp from '../../../../services/api/https/picking/picking.http'
import * as TeamHttp from '../../../../services/api/https/picking/picking-team.http'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import {
  descricaoMantemSufixoFixo,
  getSufixoFixoDescricaoPicking,
} from '../../../../services/util/picking-name.service'
import { PickingStatus } from '../../../../constants/picking-status'

const AREA_ASSOCIATION_MODELS = [
  { value: 'AIPA', label: 'Agrupar por nota/identificador' },
  { value: 'ACA', label: 'Agrupar por cliente' },
  { value: 'AU', label: 'Área Única' },
]

// Modal compartilhado para geração automática de Picking a partir da roteirização
// (Reconferência / Por Cliente / Por Cliente-Estoque), com associação de áreas,
// equipe de separação e preparação para download em uma única operação
function ModalGerarPickingAutomatico({
  isVisible,
  onClose,
  onSave,
  header,
  estilo, // 'Reconferencia' | 'Expedicao' - usado na pré-visualização da descrição
  fleetIds,
  tpId,
  dispatch,
}) {
  const [descricoes, setDescricoes] = useState([])
  const [equipes, setEquipes] = useState([])
  const [areaAssociationModel, setAreaAssociationModel] = useState(null)
  const [pickingteamId, setPickingteamId] = useState(null)
  const [prontoParaDownload, setProntoParaDownload] = useState(true)

  useEffect(() => {
    if (isVisible && fleetIds && fleetIds.length > 0) {
      setAreaAssociationModel(null)
      setPickingteamId(null)
      setProntoParaDownload(true)
      loadData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible])

  const loadData = async () => {
    try {
      const [names, teams] = await Promise.all([
        PickingHttp.previewNomePickingAhPartirRoteirizacao(fleetIds, estilo),
        TeamHttp.getEquipes(tpId),
      ])
      // Guarda o sufixo fixo ("| {placa} - {motorista} - {data}") de cada descrição:
      // só o que está à esquerda do pipe pode ser editado
      setDescricoes(
        names.map(n => ({ ...n, sufixoFixo: getSufixoFixoDescricaoPicking(n.name) })),
      )
      setEquipes(teams.filter(t => t.actived).map(t => ({ value: t.id, label: t.name })))
    } catch (error) {
      setDescricoes([])
      setEquipes([])
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  const onDescricaoChange = (index, value) => {
    setDescricoes(prev =>
      prev.map((d, i) => {
        if (i !== index) return d
        // Rejeita edições que alterem a parte fixa (do pipe em diante)
        if (!descricaoMantemSufixoFixo(value, d.sufixoFixo)) return d
        return { ...d, name: value }
      }),
    )
  }

  const onBtnSalvarClicked = () => {
    if (descricoes.some(d => !d.name || !d.name.trim())) {
      dispatch(showMessageBox(null, 'Informe a Descrição do Picking'))
      return
    }
    if (!areaAssociationModel) {
      dispatch(showMessageBox(null, 'Selecione o método de agrupamento das áreas de separação'))
      return
    }
    if (!pickingteamId) {
      dispatch(showMessageBox(null, 'Selecione a Equipe responsável pela separação'))
      return
    }
    onSave({
      area_association_model: areaAssociationModel,
      pickingteam_id: pickingteamId,
      preparar_para_download: prontoParaDownload,
      descricoes: descricoes.map(d => ({ fleet_id: d.fleet_id, name: d.name.trim() })),
    })
  }

  return (
    <CustomModal width="450px" header={header} isVisible={isVisible} onClose={onClose}>
      <div style={{ padding: '10px 10px 20px 10px' }}>
        {descricoes.map((descricao, index) => (
          <InputText
            key={descricao.fleet_id}
            label={index === 0 ? 'Descrição :' : ''}
            showLabel={index === 0}
            marginTop={index === 0 ? 5 : 8}
            value={descricao.name}
            onChange={value => onDescricaoChange(index, value)}
            name={`descricao-picking-${index}`}
          />
        ))}
        <p style={{ margin: '6px 0 0 0', fontSize: '0.78rem', color: '#555' }}>
          Só é possível editar ou acrescentar informações à esquerda de "|"
        </p>

        <p style={{ margin: '20px 0 10px 0', fontSize: '0.8rem', color: '#14b0bf' }}>
          Selecione o método de agrupamento das áreas de separação:
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {AREA_ASSOCIATION_MODELS.map(model => (
            <CustomRadioButton
              key={model.value}
              items={[model]}
              value={areaAssociationModel}
              onChange={value => setAreaAssociationModel(value)}
            />
          ))}
        </div>

        <CustomDropdown
          label="Selecione a Equipe responsável pela separação"
          marginTop={20}
          options={equipes}
          value={pickingteamId}
          onChange={value => setPickingteamId(value)}
        />

        <div style={{ marginTop: 20 }}>
          <CustomCheckbox
            checked={prontoParaDownload}
            onChange={value => setProntoParaDownload(value)}
          >
            Gerar Picking como{' '}
            <Badge color={PickingStatus.ProntoParaDownload.color}>
              {PickingStatus.ProntoParaDownload.label}
            </Badge>
          </CustomCheckbox>
          <p style={{ margin: '10px 0 0 0', fontSize: '0.78rem', color: '#555' }}>
            Ao gerar o Picking com o status Pronto Para Download ele já estará disponível
            automaticamente no App Expedição, porém não será mais possível edita-lo.
          </p>
        </div>

        <div style={{ marginTop: 25 }}>
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </div>
    </CustomModal>
  )
}

export default connect()(ModalGerarPickingAutomatico)
